import React from 'react';
import hoc from './FieldHOC';
import HelpText from './HelpText';

export default hoc(function CreditField({field, ...props}) {
  const onChange = (e) => {
    let value = e.target.value;
    value = value.replace('.', '').replace(',','').replace('$', '');
    if (isNaN(value) || value === '') {
      value = 0;
    }
    field.setSelectedValue(-parseFloat(value));
    props.onChange(value);
  };

  return <div>
    <label htmlFor={props.name}>{props.title || field.get('title')}</label>
    <HelpText field={field} helpText={props.helpText} />
    {props.errorComponent}
    <input
      className="form-control"
      name={props.name}
      aria-label={props.title || field.get('title')}
      placeholder={field.prop('hintText')}
      tabIndex={props.tabIndex}
      onChange={onChange}
      value={props.value || ''}
      disabled={props.disabled}
    />
  </div>;
})
